import http from 'common-module/src/util/http';

/**
 * 查询资源执行人负荷情况（聚合接口）
 * @param {*} data
 * @returns
 */
export async function getAssigneeResources (data) {
  return http.post('/resources-manage/assemble-info', data || {});
}

/**
 * 根据筛选条件查询资源执行人负荷情况
 * @param {*} data
 * @returns
 */
export async function queryAssigneeResources (data) {
  return http.post('/resources-manage/query-assignee-resources', data || {});
}


/**
 * 记录用户行为习惯
 * @param {*} data
 * @returns
 */
export async function habitRecord (data) {
  return http.post('/account/habit-record', data);
}

/**
 * 查询用户每天可以完成的点数(支持批量)
 * @param {*} data
 * @returns
 */
export async function queryAccountEstimatePoint (data) {
  return http.post('/account/query-account-estimate-point', data);
}

/**
 * 批量更新用户每天可以完成的点数
 * @param {*} data
 * @returns
 */
export async function batchUpdateAccountEstimatePoint (data) {
  return http.post('/account/batch-update-account-estimate-point', data);
}

/**
 * 记录用户行为习惯(多项)
 * @param {*} data
 * @returns
 */
export async function batchHabitRecord (data) {
  return http.post('/account/batch-habit-record', data);
}

/**
 * 更新issue详情
 * @param {*} data
 * @returns
 */
export async function updateIssue(data) {
  return http.post('/issue/update', data);
}

/**
 * 获取用户每天可以完成的点数
 * @param {*} data
 * @returns
 */
export async function getAccountEstimatePoint(data) {
  return http.post('/account/get-org-account-estimate-point', data);
}

/**
 * 更新用户每天可以完成的点数
 * @param {*} data
 * @returns
 */
export async function updateAccountEstimatePoint(data) {
  return http.post('/account/update-org-account-estimate-point', data);
}

/**
 * 更新用户每天可以完成的点数
 * @param {*} data
 * @returns
 */
export async function getIssueSelectOptions(data) {
  return http.post('/issue/select-options', data);
}

/**
 * 更新用户每天可以完成的点数
 * @param {*} data
 * @returns
 */
export async function getIssuesDetail (data) {
  return http.post('/resources-manage/query-issue-detail', data);
}

/**
 * 查询用户每天可以完成的工作数量(支持批量)
 * @param {*} data
 * @returns
 */
export async function getAccountIssueCount (data) {
  return http.post('/account/query-account-issue-count', data);
}

/**
 * 批量更新用户每天可以完成的工作数量
 * @param {*} data
 * @returns
 */
export async function batchUpdateAccountIssueCount (data) {
  return http.post('/account/batch-update-account-issue-count', data);
}


// 导出工时登记记录excel文件
export async function exportLabourExcel() {
  const result = await http.post('/resources-manage/export-labour-excel', {}, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
  return { result };
}

// 查询导出工时登记记录excel文件执行结果
export async function queryExcelResult(data) {
  return http.post('/resources-manage/query-excel-result', data, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
}

/**
 * 查询团队分组列表详情数据
 * @param {*} data
 * @returns
 */
export async function queryTeamGroupDetail (data) {
  return http.post('/team-group/query-team-group-detail', data);
}

/**
 * 团队添加自定义分组时，检测分组名称是否重复
 * @param {*} data
 * @returns
 */
export async function checkGroupName (data) {
  return http.post('/team-group/check-group-name-for-add', data, {
    assertResult: (res, data) => {
      if (data.code === '04104') {
        data.result = data.code;
        return true;
      }
      if (data.code === '200') {
        return true;
      }
    }
  });
}

/**
 * 团队更新自定义分组-同时更新分组成员
 * @param {*} data
 * @returns
 */
export async function updateTeamGroup (data) {
  return http.post('/team-group/update-team-group-with-user', data);
}

/**
 * 团队添加自定义分组-同时往分组添加成员
 * @param {*} data
 * @returns
 */
export async function saveTeamGroup (data) {
  return http.post('/team-group/save-team-group-with-user', data);
}

/**
 * 团队删除自定义分组
 * @param {*} data
 * @returns
 */
export async function deleteTeamGroup (data) {
  return http.post('/team-group/delete-team-group', data);
}
